import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { PhantomBitcoinInjectedProvider } from '../PhantomBitcoinInjectedProvider.types';

const PHANTOM_BITCOIN_PROVIDER_LOCATOR = 'phantom.bitcoin';

export const getPhantomInjectedProvider = () => {
  return getInjectedProviderFromWindow<PhantomBitcoinInjectedProvider>(
    PHANTOM_BITCOIN_PROVIDER_LOCATOR
  );
};
